module.exports = __webpack_public_path__ + "img/测点_平层开关.8672efc7.png";